msgid ""
msgstr ""
"POT-Creation-Date: 2026-01-18 16:02+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: pkg.totalPriceMonthly
#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "{0} €/mo"
msgstr "{0} €/mo"

#. placeholder {0}: warrantyStats.active
#: src/modules/maintenance/Summary.tsx
msgid "{0} active"
msgstr "{0} active"

#. placeholder {0}: formatDate(visitDate)
#. placeholder {1}: visitDate.toLocaleTimeString( 'fi-FI', { hour: '2-digit', minute: '2-digit', }, )
#. placeholder {2}: endTime.toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit', })
#: src/routes/_app/visits/index.tsx
msgid "{0} at {1}-{2}"
msgstr "{0} at {1}-{2}"

#. placeholder {0}: warrantyStats.expiringSoon
#: src/modules/maintenance/Summary.tsx
msgid "{0} expiring soon"
msgstr "{0} expiring soon"

#. placeholder {0}: taskAttachments.length
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "{0} photos"
msgstr "{0} photos"

#. placeholder {0}: category.taskCount
#: src/modules/maintenance/Summary.tsx
msgid "{0} tasks"
msgstr "{0} tasks"

#. placeholder {0}: pkg.quantity
#. placeholder {1}: pkg.priceMonthly
#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "{0} x {1} €/mo ="
msgstr "{0} x {1} €/mo ="

#. placeholder {0}: hasDiscount ? effectivePrice : basePrice
#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "{0}€/mo"
msgstr "{0}€/mo"

#: src/modules/visit/FutureVisit.tsx
msgid "{attendeeCount} attendees"
msgstr "{attendeeCount} attendees"

#: src/modules/home/components/MaintenanceCard.tsx
msgid "{completedCount}/{totalCount} done"
msgstr "{completedCount}/{totalCount} done"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "{dayName} {dateStr} at {startTimeStr} - {endTimeStr}"
msgstr "{dayName} {dateStr} at {startTimeStr} - {endTimeStr}"

#: src/routes/_app/maintenance-log/index.tsx
msgid "{itemYear} maintenance activities"
msgstr "{itemYear} maintenance activities"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "{priceMonthly} €/mo"
msgstr "{priceMonthly} €/mo"

#: src/modules/visit/FutureVisit.tsx
msgid "{taskCount} tasks"
msgstr "{taskCount} tasks"

#: src/components/VisitListItem.tsx
msgid "{weekday} {day}. {month}, at {startTimeStr}-{endTimeStr}"
msgstr "{weekday} {day}. {month}, at {startTimeStr}-{endTimeStr}"

#: src/modules/visit/FutureVisit.tsx
msgid "~{estimatedDuration} min"
msgstr "~{estimatedDuration} min"

#: src/components/profile/CustomerCard.tsx
#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
#: src/modules/subscription/components/PackageCard.tsx
msgid "€/mo"
msgstr "€/mo"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "1. Close your apartment's water shutoff valve"
msgstr "1. Close your apartment's water shutoff valve"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "12 tasks done, 36 remaining"
msgstr "12 tasks done, 36 remaining"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "135,00 € / pcs"
msgstr "135,00 € / pcs"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "2. Call the emergency hotline at 020 7484 00"
msgstr "2. Call the emergency hotline at 020 7484 00"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "24-hour service"
msgstr "24-hour service"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "24/7 service - including Christmas and Midsummer"
msgstr "24/7 service - including Christmas and Midsummer"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "3. Mention at the start of the call that you are a Markku.fi customer. Explain what happened and follow the instructions given to you."
msgstr "3. Mention at the start of the call that you are a Markku.fi customer. Explain what happened and follow the instructions given to you."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "4. File a claim with your insurance company"
msgstr "4. File a claim with your insurance company"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "5. Add the damage report from Polygon to your Markku maintenance log."
msgstr "5. Add the damage report from Polygon to your Markku maintenance log."

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "7 days"
msgstr "7 days"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "A centralized place for all home information and images"
msgstr "A centralized place for all home information and images"

#: src/modules/auth/WelcomeStep.tsx
msgid "A maintenance book that takes care of your home. Track maintenance needs, receive reminders and maintain your property's value."
msgstr "A maintenance book that takes care of your home. Track maintenance needs, receive reminders and maintain your property's value."

#. placeholder {0}: task.estimatedDurationHours
#: src/modules/maintenance/YearCalendarCarousel/index.tsx
msgid "About {0} hours"
msgstr "About {0} hours"

#. placeholder {0}: task.estimatedDurationMinutes
#: src/routes/_app/maintenance-log/$id.tsx
msgid "About {0} minutes"
msgstr "About {0} minutes"

#: src/modules/auth/WelcomeStep.tsx
msgid "Accept terms of service"
msgstr "Accept terms of service"

#: src/modules/subscription/components/PackageCard.tsx
#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "Activate package"
msgstr "Activate package"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
#: src/modules/subscription/components/PackageCard.tsx
#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "Active"
msgstr "Active"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
msgid "Active subscription"
msgstr "Active subscription"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Actual"
msgstr "Actual"

#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Actual cost"
msgstr "Actual cost"

#: src/modules/consumption/ConsumptionSummaryCards.tsx
#: src/modules/consumption/index.tsx
#: src/modules/costs/CostsPage/index.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Add"
msgstr "Add"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Add a detailed description of the task..."
msgstr "Add a detailed description of the task..."

#: src/components/common/AttachmentField.tsx
msgid "Add attachment"
msgstr "Add attachment"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Add cost"
msgstr "Add cost"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Add costs in the <0>Maintenance log</0>"
msgstr "Add costs in the <0>Maintenance log</0>"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Add meter reading"
msgstr "Add meter reading"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Add more detailed description..."
msgstr "Add more detailed description..."

#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Add notes about the completed work..."
msgstr "Add notes about the completed work..."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Add notes about the task..."
msgstr "Add notes about the task..."

#: src/components/profile/AddPropertyModal.tsx
#: src/components/profile/CustomerCard.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Add property"
msgstr "Add property"

#: src/modules/maintenance/YearCalendarCarousel/TaskCard.tsx
msgid "Add task"
msgstr "Add task"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Add to calendar"
msgstr "Add to calendar"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Add your first property"
msgstr "Add your first property"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Additional charges: mileage compensation €1.65/km (car/van), €2.40/km (truck), materials at Polygon list price -25% + material surcharge 12%, HVAC work and subcontracting +12%."
msgstr "Additional charges: mileage compensation €1.65/km (car/van), €2.40/km (truck), materials at Polygon list price -25% + material surcharge 12%, HVAC work and subcontracting +12%."

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Additional info..."
msgstr "Additional info..."

#: src/modules/visit/FutureVisit.tsx
msgid "Additional information"
msgstr "Additional information"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Additional information (optional)"
msgstr "Additional information (optional)"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Additional work"
msgstr "Additional work"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Additional work will be added to your next monthly invoice automatically"
msgstr "Additional work will be added to your next monthly invoice automatically"

#: src/modules/property/components/PropertyAddressCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Address"
msgstr "Address"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Address is required"
msgstr "Address is required"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "After"
msgstr "After"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Alert!"
msgstr "Alert!"

#: src/routes/_app/maintenance-log/index.tsx
msgid "All categories"
msgstr "All categories"

#: src/modules/home/components/EngagementCard.tsx
msgid "All maintenance supplies included in the price"
msgstr "All maintenance supplies included in the price"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "All OK"
msgstr "All OK"

#. placeholder {0}: allowedTypes.join(', ')
#: src/components/common/AttachmentField.tsx
msgid "Allowed types: {0}"
msgstr "Allowed types: {0}"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Amount"
msgstr "Amount"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Amount due"
msgstr "Amount due"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Annual calendar"
msgstr "Annual calendar"

#: src/components/profile/LanguageSettings.tsx
msgid "App language"
msgstr "App language"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Are you sure you want to delete this maintenance entry?"
msgstr "Are you sure you want to delete this maintenance entry?"

#. placeholder {0}: Number(consumption.meterReading).toFixed(1)
#. placeholder {1}: consumption.unit
#. placeholder {2}: formatDate(consumption.date)
#: src/modules/consumption/ConsumptionTable.tsx
msgid "Are you sure you want to delete this meter reading ({0} {1}, {2})?"
msgstr "Are you sure you want to delete this meter reading ({0} {1}, {2})?"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Are you sure you want to delete this task?"
msgstr "Are you sure you want to delete this task?"

#: src/routes/_app/profile.tsx
msgid "Are you sure you want to log out?"
msgstr "Are you sure you want to log out?"

#: src/routes/_app/messages/index.tsx
msgid "Ask questions, request help and track visits"
msgstr "Ask questions, request help and track visits"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "at"
msgstr "at"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Attachments"
msgstr "Attachments"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Attachments are saved when the task is saved"
msgstr "Attachments are saved when the task is saved"

#: src/modules/visit/FutureVisit.tsx
msgid "Attendees"
msgstr "Attendees"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Autumn"
msgstr "Autumn"

#: src/modules/auth/EmailStep.tsx
#: src/modules/auth/OtpStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Back"
msgstr "Back"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Barcode"
msgstr "Barcode"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "Before"
msgstr "Before"

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Book a free survey visit"
msgstr "Book a free survey visit"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Book visit"
msgstr "Book visit"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Booking successful!"
msgstr "Booking successful!"

#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Budget variance"
msgstr "Budget variance"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Budgeted"
msgstr "Budgeted"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Budgeted costs are calculated from task estimates"
msgstr "Budgeted costs are calculated from task estimates"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Budgeting and household deduction"
msgstr "Budgeting and household deduction"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/visit/FeedbackModal.tsx
#: src/routes/_app/maintenance-log/$id.tsx
#: src/routes/_app/profile.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Category"
msgstr "Category"

#: src/modules/visit/PastVisit/CertificatesCard.tsx
msgid "Certificate"
msgstr "Certificate"

#: src/modules/visit/PastVisit/CertificatesCard.tsx
msgid "Certificates"
msgstr "Certificates"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Certificates and user manuals"
msgstr "Certificates and user manuals"

#: src/modules/maintenance/Summary.tsx
msgid "Certificates, manuals and receipts"
msgstr "Certificates, manuals and receipts"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Change package"
msgstr "Change package"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Check"
msgstr "Check"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Check details"
msgstr "Check details"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Check form details"
msgstr "Check form details"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Check the form data"
msgstr "Check the form data"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Check your contact information"
msgstr "Check your contact information"

#. placeholder {0}: form.values.email
#: src/modules/auth/EmailStep.tsx
msgid "Check your email {0}"
msgstr "Check your email {0}"

#: src/modules/visit/PastVisit/CertificatesCard.tsx
msgid "Chimney sweep certificate"
msgstr "Chimney sweep certificate"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Choose a suitable time for the survey visit"
msgstr "Choose a suitable time for the survey visit"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "City"
msgstr "City"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Click the \"Add\" button on the card you want (electricity, water, or heating)"
msgstr "Click the \"Add\" button on the card you want (electricity, water, or heating)"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
#: src/modules/subscription/components/ContractTermsModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Close"
msgstr "Close"

#: src/modules/auth/OtpStep.tsx
msgid "Code must be 6 digits"
msgstr "Code must be 6 digits"

#: src/modules/auth/EmailStep.tsx
msgid "Code sent!"
msgstr "Code sent!"

#: src/modules/consumption/ConsumptionChart.tsx
msgid "Comparison to previous year"
msgstr "Comparison to previous year"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Completed"
msgstr "Completed"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Completed maintenance task"
msgstr "Completed maintenance task"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Completed maintenance tasks"
msgstr "Completed maintenance tasks"

#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Completed steps"
msgstr "Completed steps"

#: src/modules/visit/PastVisit/CompletedTasksList.tsx
msgid "Completed tasks"
msgstr "Completed tasks"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Completed tasks:"
msgstr "Completed tasks:"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Completed work:"
msgstr "Completed work:"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Completion date is required"
msgstr "Completion date is required"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Completion date is required when marking task as completed"
msgstr "Completion date is required when marking task as completed"

#: src/components/profile/AddPropertyModal.tsx
msgid "Construction year"
msgstr "Construction year"

#: src/modules/consumption/index.tsx
#: src/modules/consumption/index.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Consumption tracking"
msgstr "Consumption tracking"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Consumption type"
msgstr "Consumption type"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Contact"
msgstr "Contact"

#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "Contents:"
msgstr "Contents:"

#: src/modules/auth/EmailStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Continue"
msgstr "Continue"

#: src/modules/auth/GoogleButton.tsx
msgid "Continue with Google"
msgstr "Continue with Google"

#: src/modules/subscription/components/ContractTermsModal.tsx
msgid "Contract terms – Markku.fi Home Services"
msgstr "Contract terms – Markku.fi Home Services"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Copied"
msgstr "Copied"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Copy"
msgstr "Copy"

#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Cost"
msgstr "Cost"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Cost breakdown"
msgstr "Cost breakdown"

#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Cost information"
msgstr "Cost information"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Cost management"
msgstr "Cost management"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost name"
msgstr "Cost name"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost name is required"
msgstr "Cost name is required"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Cost saved"
msgstr "Cost saved"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Cost tracking"
msgstr "Cost tracking"

#: src/modules/costs/CostsPage/index.tsx
#: src/modules/costs/CostsPage/index.tsx
msgid "Costs"
msgstr "Costs"

#: src/modules/costs/CostsPage/CostsCategoryList.tsx
msgid "Costs by category"
msgstr "Costs by category"

#: src/modules/maintenance/components/FinancialQuickCard.tsx
msgid "Costs for {year}"
msgstr "Costs for {year}"

#. placeholder {0}: formatEuros(totalCost)
#: src/modules/maintenance/YearCalendarCarousel/SeasonHeader.tsx
msgid "Costs: {0}"
msgstr "Costs: {0}"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Create new task"
msgstr "Create new task"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Current"
msgstr "Current"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Customer comment:"
msgstr "Customer comment:"

#: src/components/profile/CustomerCard.tsx
msgid "Customer name"
msgstr "Customer name"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Customer rating:"
msgstr "Customer rating:"

#: src/routes/_app/messages/index.tsx
msgid "Customer service"
msgstr "Customer service"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Damage prevention (JVT)"
msgstr "Damage prevention (JVT)"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Date"
msgstr "Date"

#: src/modules/visit/FutureVisit.tsx
msgid "Date and time"
msgstr "Date and time"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Date is required"
msgstr "Date is required"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Deadline is required"
msgstr "Deadline is required"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Deadline:"
msgstr "Deadline:"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "December-February"
msgstr "December-February"

#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/routes/_app/maintenance-log/$id.tsx
#: src/routes/_app/maintenance-log/$id.tsx
msgid "Delete"
msgstr "Delete"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Delete consumption"
msgstr "Delete consumption"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Delete entry"
msgstr "Delete entry"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Delete task"
msgstr "Delete task"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Description"
msgstr "Description"

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
msgid "Details"
msgstr "Details"

#: src/routes/_app/profile.tsx
msgid "Developer settings"
msgstr "Developer settings"

#: src/modules/home/components/EngagementCard.tsx
msgid "Did you know?"
msgstr "Did you know?"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Digital maintenance book"
msgstr "Digital maintenance book"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Digital maintenance log"
msgstr "Digital maintenance log"

#: src/routes/_app/messages/index.tsx
msgid "Direct communication with maintenance staff"
msgstr "Direct communication with maintenance staff"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "discount"
msgstr "discount"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Do you only see one package?"
msgstr "Do you only see one package?"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Documents"
msgstr "Documents"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Documents and warranties"
msgstr "Documents and warranties"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Doe"
msgstr "Doe"

#: src/modules/subscription/components/ContractTermsModal.tsx
msgid "Download contract terms (PDF)"
msgstr "Download contract terms (PDF)"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Download invoice (PDF)"
msgstr "Download invoice (PDF)"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Due"
msgstr "Due"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Due date"
msgstr "Due date"

#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "During the visit, your property information was surveyed and updated."
msgstr "During the visit, your property information was surveyed and updated."

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 00100"
msgstr "e.g. 00100"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 123 Main Street"
msgstr "e.g. 123 Main Street"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 150"
msgstr "e.g. 150"

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "E.g. 150"
msgstr "E.g. 150"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. 2010"
msgstr "e.g. 2010"

#: src/components/profile/AddPropertyModal.tsx
msgid "e.g. Helsinki"
msgstr "e.g. Helsinki"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "E.g. Mannerheimintie 1"
msgstr "E.g. Mannerheimintie 1"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "E.g. Pipe renovation, HVAC maintenance"
msgstr "E.g. Pipe renovation, HVAC maintenance"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "E.g. property age, condition, or other information that may help with the survey visit"
msgstr "E.g. property age, condition, or other information that may help with the survey visit"

#: src/modules/maintenance/components/TaskDetails/index.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "E.g. Window cleaning"
msgstr "E.g. Window cleaning"

#: src/routes/_app/messages/index.tsx
msgid "Easily arrange visit times"
msgstr "Easily arrange visit times"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/consumption/ConsumptionTable.tsx
#: src/routes/_app/maintenance-log/$id.tsx
msgid "Edit"
msgstr "Edit"

#: src/components/profile/CustomerCard.tsx
msgid "Edit customer"
msgstr "Edit customer"

#: src/components/profile/PersonalInfoCard.tsx
msgid "Edit information"
msgstr "Edit information"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Edit meter reading"
msgstr "Edit meter reading"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "Edit or delete costs by opening an individual maintenance entry"
msgstr "Edit or delete costs by opening an individual maintenance entry"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Edit task"
msgstr "Edit task"

#: src/modules/maintenance/Summary.tsx
msgid "Electrical systems"
msgstr "Electrical systems"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Electricity"
msgstr "Electricity"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Electricity, water and heating"
msgstr "Electricity, water and heating"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/auth/EmailStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Email"
msgstr "Email"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Email address cannot be changed"
msgstr "Email address cannot be changed"

#. placeholder {0}: INVOICE_FEES.EMAIL
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Email invoice will be sent automatically (includes {0}€ invoicing fee). Payment period is 14 days from invoice date."
msgstr "Email invoice will be sent automatically (includes {0}€ invoicing fee). Payment period is 14 days from invoice date."

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Email invoice will be sent automatically. Payment period is 14 days from invoice date."
msgstr "Email invoice will be sent automatically. Payment period is 14 days from invoice date."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Emergency call fee"
msgstr "Emergency call fee"

#: src/modules/home/components/EngagementCard.tsx
msgid "Emergency repairs 24/7"
msgstr "Emergency repairs 24/7"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Enter the current meter reading. Consumption is calculated automatically from the previous reading."
msgstr "Enter the current meter reading. Consumption is calculated automatically from the previous reading."

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Enter the current meter reading. This will serve as the starting point for consumption calculation."
msgstr "Enter the current meter reading. This will serve as the starting point for consumption calculation."

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "Enter the total floor area to see all suitable packages"
msgstr "Enter the total floor area to see all suitable packages"

#: src/modules/auth/OtpStep.tsx
msgid "Enter verification code"
msgstr "Enter verification code"

#: src/modules/auth/EmailStep.tsx
msgid "Enter your email address"
msgstr "Enter your email address"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Enter your property's total floor area in the card above, and we'll show you all suitable Markku packages."
msgstr "Enter your property's total floor area in the card above, and we'll show you all suitable Markku packages."

#: src/components/ErrorAlert.tsx
#: src/components/profile/AddPropertyModal.tsx
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/billing.ts
#: src/lib/trpcHooks/invoice.ts
#: src/lib/trpcHooks/user.ts
#: src/lib/trpcHooks/user.ts
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/visit/FeedbackModal.tsx
#: src/routes/impersonate.tsx
msgid "Error"
msgstr "Error"

#: src/modules/maintenanceLog/detail/CostSummaryCard.tsx
msgid "Estimate"
msgstr "Estimate"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Estimated cost (optional)"
msgstr "Estimated cost (optional)"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "Estimated end time at"
msgstr "Estimated end time at"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Estimated end time at {formattedEndTime}"
msgstr "Estimated end time at {formattedEndTime}"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Example Street 1"
msgstr "Example Street 1"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Explore Markku packages"
msgstr "Explore Markku packages"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "Explore packages"
msgstr "Explore packages"

#: src/modules/maintenance/Summary.tsx
msgid "Facade"
msgstr "Facade"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to accept offer"
msgstr "Failed to accept offer"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to create payment"
msgstr "Failed to create payment"

#: src/lib/trpcHooks/billing.ts
msgid "Failed to create payment session"
msgstr "Failed to create payment session"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Failed to delete task"
msgstr "Failed to delete task"

#: src/components/ErrorAlert.tsx
msgid "Failed to load data. Please try again."
msgstr "Failed to load data. Please try again."

#: src/lib/trpcHooks/billing.ts
msgid "Failed to open billing portal"
msgstr "Failed to open billing portal"

#: src/lib/trpcHooks/invoice.ts
msgid "Failed to open payment page"
msgstr "Failed to open payment page"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Failed to save cost"
msgstr "Failed to save cost"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Failed to save task"
msgstr "Failed to save task"

#: src/lib/trpcHooks/user.ts
msgid "Failed to update information"
msgstr "Failed to update information"

#: src/lib/trpcHooks/user.ts
msgid "Failed to update settings"
msgstr "Failed to update settings"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Fall tasks"
msgstr "Fall tasks"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "fall's"
msgstr "fall's"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "First meter reading"
msgstr "First meter reading"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "First name"
msgstr "First name"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "First name is required"
msgstr "First name is required"

#: src/components/profile/AddPropertyModal.tsx
msgid "Floor area in square meters (m²)"
msgstr "Floor area in square meters (m²)"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Follow seasonal maintenance tasks and keep your home in shape all year round"
msgstr "Follow seasonal maintenance tasks and keep your home in shape all year round"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "FREE"
msgstr "FREE"

#: src/modules/visit/FeedbackModal.tsx
msgid "Free feedback (optional)"
msgstr "Free feedback (optional)"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Free maintenance program for your property"
msgstr "Free maintenance program for your property"

#: src/components/profile/AddPropertyModal.tsx
msgid "Free-form notes about the property"
msgstr "Free-form notes about the property"

#: src/modules/maintenance/Summary.tsx
msgid "Full maintenance history"
msgstr "Full maintenance history"

#: src/modules/home/components/EngagementCard.tsx
msgid "Get a free month when your friend joins"
msgstr "Get a free month when your friend joins"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Get additional help at home"
msgstr "Get additional help at home"

#: src/modules/auth/WelcomeStep.tsx
msgid "Get started"
msgstr "Get started"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgctxt "subscription"
msgid "Get started"
msgstr "Get started"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Get tips for home maintenance and special offers from our partners"
msgstr "Get tips for home maintenance and special offers from our partners"

#: src/components/VisitListItem.tsx
#: src/modules/home/components/EngagementCard.tsx
#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Give feedback"
msgstr "Give feedback"

#: src/modules/visit/FeedbackModal.tsx
msgid "Great that the visit went well!"
msgstr "Great that the visit went well!"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Gutter cleaning"
msgstr "Gutter cleaning"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Heating"
msgstr "Heating"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Heating summer setting"
msgstr "Heating summer setting"

#: src/modules/maintenance/Summary.tsx
msgid "Heating systems"
msgstr "Heating systems"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Helps with budgeting and annual planning"
msgstr "Helps with budgeting and annual planning"

#: src/config/navigation.tsx
msgid "Home"
msgstr "Home"

#: src/modules/home/components/EngagementCard.tsx
#: src/modules/visit/FeedbackModal.tsx
msgid "How did the visit go?"
msgstr "How did the visit go?"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "How did the visit go? Your feedback helps us improve our service."
msgstr "How did the visit go? Your feedback helps us improve our service."

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "How to get started:"
msgstr "How to get started:"

#: src/modules/visit/FeedbackModal.tsx
msgid "How would you rate Markku's visit?"
msgstr "How would you rate Markku's visit?"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Humidity"
msgstr "Humidity"

#: src/modules/maintenance/Summary.tsx
msgid "HVAC systems"
msgstr "HVAC systems"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "I accept the"
msgstr "I accept the"

#: src/modules/subscription/components/PackageCard.tsx
msgid "I accept the <0>contract terms</0>"
msgstr "I accept the <0>contract terms</0>"

#: src/modules/auth/WelcomeStep.tsx
msgid "I accept the <0>terms of service</0> and <1>privacy policy</1>"
msgstr "I accept the <0>terms of service</0> and <1>privacy policy</1>"

#: src/components/property/WelcomePropertyModal.tsx
msgid "I want to receive Markku maintenance offers and benefits"
msgstr "I want to receive Markku maintenance offers and benefits"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "IBAN"
msgstr "IBAN"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "If you are interested in our services, contact us:"
msgstr "If you are interested in our services, contact us:"

#. placeholder {0}: INVOICE_FEES.EMAIL
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "If you don't pay in app by the deadline, we will send an email invoice (includes {0}€ invoicing fee). Invoice payment period is 14 days."
msgstr "If you don't pay in app by the deadline, we will send an email invoice (includes {0}€ invoicing fee). Invoice payment period is 14 days."

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "If you don't pay in app by the deadline, we will send an email invoice. Invoice payment period is 14 days."
msgstr "If you don't pay in app by the deadline, we will send an email invoice. Invoice payment period is 14 days."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "If you have questions about this task or notice a problem, contact our customer service."
msgstr "If you have questions about this task or notice a problem, contact our customer service."

#: src/routes/impersonate.tsx
msgid "Impersonation failed"
msgstr "Impersonation failed"

#: src/routes/impersonate.tsx
msgid "Impersonation successful"
msgstr "Impersonation successful"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "In many cases, the insurance company will reimburse the costs of damage prevention, but each case is handled individually."
msgstr "In many cases, the insurance company will reimburse the costs of damage prevention, but each case is handled individually."

#: src/modules/subscription/components/PackageCard.tsx
msgid "Includes:"
msgstr "Includes:"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Indoor air specialist"
msgstr "Indoor air specialist"

#: src/lib/trpcHooks/user.ts
#: src/lib/trpcHooks/user.ts
msgid "Information updated"
msgstr "Information updated"

#: src/modules/auth/EmailStep.tsx
msgid "Invalid email address"
msgstr "Invalid email address"

#: src/components/common/AttachmentField.tsx
msgid "Invalid file type"
msgstr "Invalid file type"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Invalid phone number"
msgstr "Invalid phone number"

#: src/modules/home/components/EngagementCard.tsx
msgid "Invite a friend"
msgstr "Invite a friend"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoice"
msgstr "Invoice"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoiced work:"
msgstr "Invoiced work:"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Invoices"
msgstr "Invoices"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "John"
msgstr "John"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "June-August"
msgstr "June-August"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Last name"
msgstr "Last name"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Last name is required"
msgstr "Last name is required"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Lawn spring maintenance"
msgstr "Lawn spring maintenance"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "LEAK!"
msgstr "LEAK!"

#: src/modules/home/components/EngagementCard.tsx
msgid "Learn about Markku service"
msgstr "Learn about Markku service"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Leave empty if no costs incurred"
msgstr "Leave empty if no costs incurred"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "Less worry, more time"
msgstr "Less worry, more time"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgid "Let Markku take care of it!"
msgstr "Let Markku take care of it!"

#: src/modules/maintenance/Summary.tsx
msgid "List of all maintenance records"
msgstr "List of all maintenance records"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Live"
msgstr "Live"

#: src/components/profile/AddPropertyModal.tsx
msgid "Living area"
msgstr "Living area"

#: src/modules/maintenance/YearCalendarCarousel/index.tsx
msgid "Loading maintenance tasks..."
msgstr "Loading maintenance tasks..."

#: src/modules/maintenance/Summary.tsx
msgid "Loading summary..."
msgstr "Loading summary..."

#: src/routes/_app/messages/$id.tsx
msgid "Loading..."
msgstr "Loading..."

#: src/modules/visit/FutureVisit.tsx
msgid "Location"
msgstr "Location"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Locking"
msgstr "Locking"

#: src/modules/auth/OtpStep.tsx
msgid "Log in"
msgstr "Log in"

#: src/routes/_app/profile.tsx
#: src/routes/_app/profile.tsx
#: src/routes/_app/profile.tsx
msgid "Log out"
msgstr "Log out"

#: src/modules/auth/OtpStep.tsx
msgid "Login code"
msgstr "Login code"

#: src/modules/auth/WelcomeLogin.tsx
msgid "Login required"
msgstr "Login required"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Maintain property information"
msgstr "Maintain property information"

#: src/config/navigation.tsx
msgid "Maintenance"
msgstr "Maintenance"

#: src/modules/maintenance/Summary.tsx
msgid "Maintenance categories"
msgstr "Maintenance categories"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
#: src/routes/_app/maintenance-log/index.tsx
msgid "Maintenance history"
msgstr "Maintenance history"

#: src/routes/_app/visits/index.tsx
msgid "Maintenance history and visit records"
msgstr "Maintenance history and visit records"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Maintenance log"
msgstr "Maintenance log"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Maintenance task"
msgstr "Maintenance task"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Maintenance task not found"
msgstr "Maintenance task not found"

#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
msgid "Manage"
msgstr "Manage"

#: src/components/profile/CustomerCard.tsx
msgid "Manage payment method and invoices"
msgstr "Manage payment method and invoices"

#: src/modules/maintenance/Summary.tsx
msgid "Manage property information"
msgstr "Manage property information"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Manage your subscription"
msgstr "Manage your subscription"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "March-May"
msgstr "March-May"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Mark as completed"
msgstr "Mark as completed"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Markku currently serves the Helsinki metropolitan area and its surroundings."
msgstr "Markku currently serves the Helsinki metropolitan area and its surroundings."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Markku customer prices (incl. VAT 25.5%):"
msgstr "Markku customer prices (incl. VAT 25.5%):"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "Markku handles"
msgstr "Markku handles"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Markku handles this task"
msgstr "Markku handles this task"

#: src/modules/subscription/components/SubscriptionOverviewCard.tsx
#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Markku package"
msgstr "Markku package"

#: src/routes/_app/maintenance-services.tsx
msgid "Markku packages"
msgstr "Markku packages"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "Markku recommends for you"
msgstr "Markku recommends for you"

#: src/modules/home/components/EngagementCard.tsx
msgid "Markku service includes:"
msgstr "Markku service includes:"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Markku service technician"
msgstr "Markku service technician"

#: src/routes/_app/visits/index.tsx
msgid "Markku takes care of your home maintenance"
msgstr "Markku takes care of your home maintenance"

#: src/routes/_app/visits/index.tsx
msgid "Markku.fi is a home maintenance service in the Helsinki metropolitan area. After activating your subscription, Markku will regularly visit your home to handle the maintenance tasks included in the contract and, if needed, small repairs and installations."
msgstr "Markku.fi is a home maintenance service in the Helsinki metropolitan area. After activating your subscription, Markku will regularly visit your home to handle the maintenance tasks included in the contract and, if needed, small repairs and installations."

#: src/routes/_app/messages/index.tsx
msgid "Markku.fi subscribers can message directly with maintenance staff to arrange visit times, ask questions and request help with small repairs or installations."
msgstr "Markku.fi subscribers can message directly with maintenance staff to arrange visit times, ask questions and request help with small repairs or installations."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Markku.fi survey visit"
msgstr "Markku.fi survey visit"

#: src/modules/home/components/UpcomingVisitCard.tsx
#: src/routes/_app/visits/index.tsx
msgid "Markku's next visit"
msgstr "Markku's next visit"

#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
#: src/modules/visit/PastVisit/VisitNotesCard.tsx
msgid "Markku's notes"
msgstr "Markku's notes"

#: src/routes/_app/visits/index.tsx
msgid "Markku's visits"
msgstr "Markku's visits"

#: src/components/profile/CustomerCard.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Member"
msgstr "Member"

#: src/components/profile/CustomerCard.tsx
msgid "Members"
msgstr "Members"

#: src/config/navigation.tsx
#: src/routes/_app/messages/index.tsx
#: src/routes/_app/messages/index.tsx
#: src/routes/_app/messages/index.tsx
msgid "Messages"
msgstr "Messages"

#: src/routes/_app/messages/index.tsx
msgid "Messages with Markku"
msgstr "Messages with Markku"

#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/consumption/ConsumptionTable.tsx
msgid "Meter reading"
msgstr "Meter reading"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Meter reading must be positive"
msgstr "Meter reading must be positive"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Meter readings"
msgstr "Meter readings"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Moisture/fire damage assessment"
msgstr "Moisture/fire damage assessment"

#: src/modules/consumption/ConsumptionChart.tsx
msgid "Monthly consumption"
msgstr "Monthly consumption"

#: src/modules/costs/CostsPage/CostsMonthlyChart.tsx
msgid "Monthly costs"
msgstr "Monthly costs"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "My tasks"
msgstr "My tasks"

#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "Name"
msgstr "Name"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "New"
msgstr "New"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "New additional work will be added automatically to your next monthly invoice. You don't need to do anything."
msgstr "New additional work will be added automatically to your next monthly invoice. You don't need to do anything."

#: src/modules/home/components/ActivityFeed.tsx
msgid "News"
msgstr "News"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Next time, consumption is calculated automatically: new reading - previous reading"
msgstr "Next time, consumption is calculated automatically: new reading - previous reading"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Next visit"
msgstr "Next visit"

#: src/routes/_app/visits/index.tsx
msgid "Next visit will be arranged separately"
msgstr "Next visit will be arranged separately"

#: src/components/profile/CustomerCard.tsx
msgid "No active subscription"
msgstr "No active subscription"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "No available times for the selected day, check the next day."
msgstr "No available times for the selected day, check the next day."

#: src/routes/_app/maintenance-log/index.tsx
msgid "No completed maintenance tasks with selected filters"
msgstr "No completed maintenance tasks with selected filters"

#: src/routes/_app/messages/index.tsx
msgid "No conversations yet"
msgstr "No conversations yet"

#: src/routes/_app/maintenance.tsx
msgid "No customer"
msgstr "No customer"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No Markku tasks for this season"
msgstr "No Markku tasks for this season"

#: src/routes/_app/messages/index.tsx
msgid "No messages yet - start a conversation"
msgstr "No messages yet - start a conversation"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No personal tasks for this season"
msgstr "No personal tasks for this season"

#: src/components/profile/CustomerCard.tsx
msgid "No properties"
msgstr "No properties"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "No recommended tasks for this season"
msgstr "No recommended tasks for this season"

#: src/modules/subscription/components/NoSubscriptionCard.tsx
msgid "No stress, no hard work - just a well-maintained home"
msgstr "No stress, no hard work - just a well-maintained home"

#: src/components/VisitListItem.tsx
msgid "No tasks"
msgstr "No tasks"

#: src/routes/_app/visits/index.tsx
msgid "No upcoming visits"
msgstr "No upcoming visits"

#. placeholder {0}: step.notes
#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Note: {0}"
msgstr "Note: {0}"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Note: If the work is covered by an insurance company, the prices agreed between Polygon and the insurance company apply."
msgstr "Note: If the work is covered by an insurance company, the prices agreed between Polygon and the insurance company apply."

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Notes"
msgstr "Notes"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Notes (optional)"
msgstr "Notes (optional)"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Notes about the task (optional)"
msgstr "Notes about the task (optional)"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Notes saved"
msgstr "Notes saved"

#: src/modules/home/components/Header.tsx
msgid "Notifications"
msgstr "Notifications"

#: src/modules/maintenance/components/YearSummaryCard.tsx
msgid "Of the year's <0>{totalTasks}</0> tasks, <1>Markku handles {markkuTasks}</1>, saving you approximately <2>{savedHours} hours</2>."
msgstr "Of the year's <0>{totalTasks}</0> tasks, <1>Markku handles {markkuTasks}</1>, saving you approximately <2>{savedHours} hours</2>."

#: src/modules/subscription/components/PackageCard.tsx
msgid "Only the owner can subscribe to packages"
msgstr "Only the owner can subscribe to packages"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Open"
msgstr "Open"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
msgid "Open history"
msgstr "Open history"

#: src/modules/home/components/MaintenanceCard.tsx
msgid "Open maintenance book"
msgstr "Open maintenance book"

#: src/modules/auth/WelcomeStep.tsx
msgid "or"
msgstr "or"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Order additional services"
msgstr "Order additional services"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Other"
msgstr "Other"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Other address"
msgstr "Other address"

#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Our customer service is open on weekdays 8-16"
msgstr "Our customer service is open on weekdays 8-16"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Outside service area"
msgstr "Outside service area"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Overdue"
msgstr "Overdue"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Overtime and additional fees: Overtime is charged according to actual hours with percentage increases per the Technology Industry Workers' Collective Agreement. Holiday eve +100% (previous weekday 18:00 – next day 06:00), Public holiday +100% (previous weekday/Saturday 18:00 – next weekday 06:00)."
msgstr "Overtime and additional fees: Overtime is charged according to actual hours with percentage increases per the Technology Industry Workers' Collective Agreement. Holiday eve +100% (previous weekday 18:00 – next day 06:00), Public holiday +100% (previous weekday/Saturday 18:00 – next weekday 06:00)."

#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Overview"
msgstr "Overview"

#: src/components/profile/CustomerCard.tsx
#: src/components/profile/CustomerCard.tsx
msgid "Owner"
msgstr "Owner"

#: src/modules/subscription/components/SubscriptionPackageList.tsx
msgid "Package"
msgstr "Package"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Paid"
msgstr "Paid"

#. placeholder {0}: formatDate(paidDate)
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Paid {0}"
msgstr "Paid {0}"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Paid work:"
msgstr "Paid work:"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Part of the Markku package"
msgstr "Part of the Markku package"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Partially paid"
msgstr "Partially paid"

#: src/routes/_app/visits/$id.tsx
msgid "Past visit"
msgstr "Past visit"

#. placeholder {0}: formatDateTime(deadline.toISOString())
#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Pay in app before {0}"
msgstr "Pay in app before {0}"

#. placeholder {0}: formatDateTime(deadline.toISOString())
#. placeholder {1}: INVOICE_FEES.EMAIL
#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Pay in app before {0} and save {1}€ invoicing fee"
msgstr "Pay in app before {0} and save {1}€ invoicing fee"

#. placeholder {0}: INVOICE_FEES.EMAIL
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Pay in app before deadline and save {0}€"
msgstr "Pay in app before deadline and save {0}€"

#: src/modules/home/components/VisitPaymentBanner.tsx
#: src/modules/visit/PastVisit/InvoiceItem.tsx
#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Pay now"
msgstr "Pay now"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment"
msgstr "Payment"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment deadline"
msgstr "Payment deadline"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Payment deadline in app has expired"
msgstr "Payment deadline in app has expired"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "PDF invoice download failed. Please try again later."
msgstr "PDF invoice download failed. Please try again later."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Peace of mind and time savings"
msgstr "Peace of mind and time savings"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Peace of mind around the clock"
msgstr "Peace of mind around the clock"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Performed by"
msgstr "Performed by"

#: src/components/profile/NotificationSettings.tsx
msgid "Permission denied in browser"
msgstr "Permission denied in browser"

#: src/components/profile/PersonalInfoCard.tsx
msgid "Personal information"
msgstr "Personal information"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Phone number"
msgstr "Phone number"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Phone number is required"
msgstr "Phone number is required"

#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Photos"
msgstr "Photos"

#: src/modules/visit/FutureVisit.tsx
msgid "Planned tasks"
msgstr "Planned tasks"

#: src/components/profile/AddPropertyModal.tsx
msgid "Please fill in all required fields"
msgstr "Please fill in all required fields"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Pool"
msgstr "Pool"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Postal code"
msgstr "Postal code"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Postal code is required"
msgstr "Postal code is required"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Postal code must be 5 digits"
msgstr "Postal code must be 5 digits"

#. placeholder {0}: calculation.previousReading.toFixed(1)
#. placeholder {1}: form.values.unit
#. placeholder {2}: formatDate(calculation.previousDate!)
#: src/modules/consumption/ConsumptionModal.tsx
msgid "Previous reading: {0} {1} ({2})"
msgstr "Previous reading: {0} {1} ({2})"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Price"
msgstr "Price"

#: src/routes/_app/visits/index.tsx
msgid "Professional maintenance staff handles the tasks"
msgstr "Professional maintenance staff handles the tasks"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Professionals handle the tasks"
msgstr "Professionals handle the tasks"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Professionals on site quickly"
msgstr "Professionals on site quickly"

#: src/config/navigation.tsx
#: src/routes/_app/profile.tsx
msgid "Profile"
msgstr "Profile"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Project management"
msgstr "Project management"

#: src/components/profile/CustomerCard.tsx
msgid "Properties"
msgstr "Properties"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/properties/$propertyId/index.tsx
msgid "Property"
msgstr "Property"

#. placeholder {0}: p.id
#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Property {0}"
msgstr "Property {0}"

#: src/components/property/WelcomePropertyModal.tsx
#: src/components/property/WelcomePropertyModal.tsx
#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Property details"
msgstr "Property details"

#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "Property information updated"
msgstr "Property information updated"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Property type"
msgstr "Property type"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "Property type is required"
msgstr "Property type is required"

#: src/components/profile/NotificationSettings.tsx
msgid "Push notifications"
msgstr "Push notifications"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "QR code"
msgstr "QR code"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Quick actions"
msgstr "Quick actions"

#: src/components/profile/NotificationSettings.tsx
msgid "Receive notifications"
msgstr "Receive notifications"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Recipient"
msgstr "Recipient"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Recommended for you"
msgstr "Recommended for you"

#: src/modules/maintenance/YearCalendarCarousel/SeasonCard.tsx
msgid "Recommended tasks"
msgstr "Recommended tasks"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Reference"
msgstr "Reference"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Regular maintenance - no surprises"
msgstr "Regular maintenance - no surprises"

#: src/modules/home/components/EngagementCard.tsx
msgid "Regular maintenance visits from professionals"
msgstr "Regular maintenance visits from professionals"

#: src/routes/_app/visits/index.tsx
msgid "Regular maintenance visits year-round"
msgstr "Regular maintenance visits year-round"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "remaining"
msgstr "remaining"

#. placeholder {0}: invoice.voidedInvoice.invoiceNumber
#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Replaces invoice {0}"
msgstr "Replaces invoice {0}"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Reschedule visit"
msgstr "Reschedule visit"

#: src/modules/auth/OtpStep.tsx
msgid "Resend code"
msgstr "Resend code"

#: src/modules/maintenance/Summary.tsx
msgid "Roof and attic"
msgstr "Roof and attic"

#: src/components/profile/AddPropertyModal.tsx
#: src/components/profile/CustomerCard.tsx
#: src/components/profile/PersonalInfoCard.tsx
#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Save"
msgstr "Save"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Save failed"
msgstr "Save failed"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Save home details, photos and technical system documentation"
msgstr "Save home details, photos and technical system documentation"

#: src/modules/visit/FeedbackModal.tsx
msgid "Saving feedback failed. Please try again."
msgstr "Saving feedback failed. Please try again."

#: src/modules/visit/PastVisit/WireTransferModal.tsx
#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Scan with your banking app"
msgstr "Scan with your banking app"

#: src/modules/visit/FutureVisit.tsx
msgid "Scheduled"
msgstr "Scheduled"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Select a suitable Markku package for your property. We handle all necessary maintenance and keep your property in good condition."
msgstr "Select a suitable Markku package for your property. We handle all necessary maintenance and keep your property in good condition."

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Select category"
msgstr "Select category"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Select city"
msgstr "Select city"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Select date"
msgstr "Select date"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/DateTimeStep.tsx
msgid "Select date and time"
msgstr "Select date and time"

#: src/modules/consumption/ConsumptionModal.tsx
msgid "Select day"
msgstr "Select day"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "Select package"
msgstr "Select package"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Select property"
msgstr "Select property"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Select target"
msgstr "Select target"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/consumption/ConsumptionModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/PropertySelector.tsx
msgid "Select type"
msgstr "Select type"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Select year"
msgstr "Select year"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "September-November"
msgstr "September-November"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Service"
msgstr "Service"

#: src/modules/subscription/components/ServicePromotionCard.tsx
msgid "Service available in the Helsinki metropolitan area and nearby regions"
msgstr "Service available in the Helsinki metropolitan area and nearby regions"

#: src/modules/home/components/EngagementCard.tsx
msgid "Share your invite link"
msgstr "Share your invite link"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Show all"
msgstr "Show all"

#: src/modules/subscription/components/ActiveSubscriptionDetails.tsx
msgid "Show contract terms"
msgstr "Show contract terms"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Show details"
msgstr "Show details"

#: src/routes/_app/profile.tsx
msgid "Show placeholder content"
msgstr "Show placeholder content"

#. placeholder {0}: userData.firstName
#. placeholder {1}: userData.lastName
#: src/routes/impersonate.tsx
msgid "Signed in as {0} {1}"
msgstr "Signed in as {0} {1}"

#: src/modules/auth/GoogleButton.tsx
#: src/modules/auth/GoogleCallback.tsx
#: src/routes/impersonate.tsx
msgid "Signing in..."
msgstr "Signing in..."

#: src/modules/visit/FeedbackModal.tsx
msgid "Sorry that the visit didn't meet your expectations"
msgstr "Sorry that the visit didn't meet your expectations"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Special cleaning"
msgstr "Special cleaning"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Spring"
msgstr "Spring"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Spring tasks"
msgstr "Spring tasks"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "spring's"
msgstr "spring's"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Start by adding a property"
msgstr "Start by adding a property"

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/profile.tsx
msgid "Start by adding a property for the maintenance log"
msgstr "Start by adding a property for the maintenance log"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Start consumption tracking"
msgstr "Start consumption tracking"

#. placeholder {0}: index + 1
#: src/modules/maintenanceLog/detail/CompletedStepsCard.tsx
msgid "Step {0}"
msgstr "Step {0}"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Store documents"
msgstr "Store documents"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Store warranties, receipts and important documents safely in one place"
msgstr "Store warranties, receipts and important documents safely in one place"

#: src/components/profile/AddPropertyModal.tsx
#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Street address"
msgstr "Street address"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Street address is required"
msgstr "Street address is required"

#: src/modules/visit/FeedbackModal.tsx
msgid "Submit feedback"
msgstr "Submit feedback"

#: src/modules/subscription/components/PackageCard.tsx
msgid "Subscribe to package"
msgstr "Subscribe to package"

#: src/modules/costs/CostsPage/CostEntryModal.tsx
#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Success"
msgstr "Success"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Summer"
msgstr "Summer"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Summer tasks"
msgstr "Summer tasks"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "summer's"
msgstr "summer's"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Survey visit - Markku.fi"
msgstr "Survey visit - Markku.fi"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Take care of your home easily. Markku helps you track your property's maintenance work, store important documents and maintain your home's value."
msgstr "Take care of your home easily. Markku helps you track your property's maintenance work, store important documents and maintain your home's value."

#: src/modules/costs/CostsPage/CostEntryModal.tsx
msgid "Target"
msgstr "Target"

#: src/modules/costs/CostsPage/CostsItemsTable.tsx
msgid "Task"
msgstr "Task"

#. placeholder {0}: index + 1
#: src/modules/visit/FutureVisit.tsx
#: src/modules/visit/PastVisit/TaskAccordionItem.tsx
msgid "Task {0}"
msgstr "Task {0}"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task deadline"
msgstr "Task deadline"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task deleted"
msgstr "Task deleted"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Task details"
msgstr "Task details"

#: src/modules/maintenance/components/TaskDetails/index.tsx
msgid "Task is already completed"
msgstr "Task is already completed"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Task marked as completed"
msgstr "Task marked as completed"

#: src/routes/_app/maintenance-log/$id.tsx
msgid "Task not found"
msgstr "Task not found"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task saved"
msgstr "Task saved"

#: src/modules/maintenance/components/TaskDetails/index.tsx
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task title"
msgstr "Task title"

#: src/modules/maintenance/components/TaskDetailsModal.tsx
msgid "Task title is required"
msgstr "Task title is required"

#: src/modules/maintenance/components/SystemTaskDetailsModal.tsx
msgid "Task to be handled"
msgstr "Task to be handled"

#: src/modules/maintenanceLog/detail/LogSummaryCard.tsx
msgid "Task type"
msgstr "Task type"

#. placeholder {0}: getSeasonName(deadlineSeason)
#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "Task will be added to the {0} list based on the deadline"
msgstr "Task will be added to the {0} list based on the deadline"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "tasks"
msgstr "tasks"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "tasks paid"
msgstr "tasks paid"

#: src/modules/visit/FeedbackModal.tsx
msgid "Tell us how we could serve you better..."
msgstr "Tell us how we could serve you better..."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/AddressStep.tsx
msgid "Tell us the property location and type"
msgstr "Tell us the property location and type"

#: src/modules/visit/FeedbackModal.tsx
msgid "Tell us what you especially appreciated about the visit..."
msgstr "Tell us what you especially appreciated about the visit..."

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Temperature"
msgstr "Temperature"

#: src/modules/subscription/components/ProposalActivationCard.tsx
msgid "terms and conditions"
msgstr "terms and conditions"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Terrace maintenance"
msgstr "Terrace maintenance"

#. placeholder {0}: user.firstName
#. placeholder {1}: user.lastName
#: src/components/ImpersonationBanner.tsx
msgid "Test mode: Logged in as {0} {1}"
msgstr "Test mode: Logged in as {0} {1}"

#: src/modules/visit/FeedbackModal.tsx
msgid "Thank you for your feedback"
msgstr "Thank you for your feedback"

#: src/modules/visit/FeedbackModal.tsx
msgid "Thank you for your feedback!"
msgstr "Thank you for your feedback!"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "The additional work listed below will be added automatically to your next monthly invoice. You don't need to do anything."
msgstr "The additional work listed below will be added automatically to your next monthly invoice. You don't need to do anything."

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "The annual calendar reminds you of seasonal maintenance tasks"
msgstr "The annual calendar reminds you of seasonal maintenance tasks"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The apartment's water shutoff valve is usually found in your apartment's utility room near the main water meter."
msgstr "The apartment's water shutoff valve is usually found in your apartment's utility room near the main water meter."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The call is directed to our partner Polygon's emergency service, which is available 24/7. In addition to water damage, you can report minor fire damage, such as when smoke has entered the apartment."
msgstr "The call is directed to our partner Polygon's emergency service, which is available 24/7. In addition to water damage, you can report minor fire damage, such as when smoke has entered the apartment."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "The customer relationship is established between you and Polygon during the call. They will bill you directly for the emergency visit and damage prevention. We have negotiated the discounted prices shown below for Markku customers."
msgstr "The customer relationship is established between you and Polygon during the call. They will bill you directly for the emergency visit and damage prevention. We have negotiated the discounted prices shown below for Markku customers."

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "The maintenance book helps you:"
msgstr "The maintenance book helps you:"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "The visit takes about an hour"
msgstr "The visit takes about an hour"

#: src/routes/_app/messages/$id.tsx
msgid "This is a shared conversation - all members of your household can read and send messages"
msgstr "This is a shared conversation - all members of your household can read and send messages"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "This maintenance task is part of the Markku package. When you get the package, professionals will handle this task for you."
msgstr "This maintenance task is part of the Markku package. When you get the package, professionals will handle this task for you."

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "This maintenance task is part of your Markku service agreement. Markku's professionals will handle this task for you according to the agreed schedule."
msgstr "This maintenance task is part of your Markku service agreement. Markku's professionals will handle this task for you according to the agreed schedule."

#: src/modules/consumption/ConsumptionModal.tsx
msgid "This will serve as the starting point. The next reading will show consumption."
msgstr "This will serve as the starting point. The next reading will show consumption."

#: src/modules/subscription/components/BookSurveyVisitModal/index.tsx
msgid "Time"
msgstr "Time"

#: src/components/property/WelcomePropertyModal.tsx
msgid "To maintenance log"
msgstr "To maintenance log"

#: src/routes/_app/visits/index.tsx
msgid "Today"
msgstr "Today"

#: src/routes/_app/visits/index.tsx
msgid "Tomorrow"
msgstr "Tomorrow"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Total"
msgstr "Total"

#: src/modules/property/components/PropertyAddressCard.tsx
msgid "Total floor area"
msgstr "Total floor area"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Total paid"
msgstr "Total paid"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Total to pay"
msgstr "Total to pay"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Track annual maintenance"
msgstr "Track annual maintenance"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "Track your electricity, water, and heating consumption using meter readings."
msgstr "Track your electricity, water, and heating consumption using meter readings."

#: src/routes/_app/maintenance.tsx
#: src/routes/_app/maintenance.tsx
msgid "Tracking and summary"
msgstr "Tracking and summary"

#: src/modules/consumption/ConsumptionTable.tsx
msgid "Type"
msgstr "Type"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Unfortunately, we do not yet serve your selected area."
msgstr "Unfortunately, we do not yet serve your selected area."

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Unlock all features"
msgstr "Unlock all features"

#: src/modules/maintenanceLog/detail/AttachmentsCard.tsx
msgid "Unnamed file"
msgstr "Unnamed file"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Unpaid"
msgstr "Unpaid"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Unpaid tasks:"
msgstr "Unpaid tasks:"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Unpaid visit"
msgstr "Unpaid visit"

#: src/modules/visit/PastVisit/VisitPaymentCard.tsx
msgid "Unpaid work:"
msgstr "Unpaid work:"

#: src/routes/_app/visits/$id.tsx
msgid "Upcoming visit"
msgstr "Upcoming visit"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Upgrade to Markku service"
msgstr "Upgrade to Markku service"

#: src/modules/maintenance/Summary.tsx
msgid "Ventilation"
msgstr "Ventilation"

#: src/modules/visit/PastVisit/VisitNotesCard.tsx
msgid "Video summary"
msgstr "Video summary"

#: src/modules/maintenance/YearCalendarCarousel/HistoryLinkCard.tsx
msgid "View all completed maintenance tasks"
msgstr "View all completed maintenance tasks"

#: src/modules/home/components/QuickActionsList.tsx
msgid "View maintenance history and tasks"
msgstr "View maintenance history and tasks"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/visit/PastVisit/PropertySurveyCard.tsx
msgid "View property details"
msgstr "View property details"

#: src/modules/home/components/UpcomingVisitCard.tsx
msgid "View visit details"
msgstr "View visit details"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Virtual barcode"
msgstr "Virtual barcode"

#: src/modules/visit/FeedbackModal.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Visit"
msgstr "Visit"

#: src/modules/home/components/EngagementCard.tsx
msgid "Visit 28.4.2025 - Matti Meikäläinen"
msgstr "Visit 28.4.2025 - Matti Meikäläinen"

#: src/modules/visit/FutureVisit.tsx
msgid "Visit details"
msgstr "Visit details"

#: src/routes/_app/visits/index.tsx
msgid "Visit history"
msgstr "Visit history"

#: src/routes/_app/visits/$id.tsx
#: src/routes/_app/visits/$id.tsx
msgid "Visit not found"
msgstr "Visit not found"

#: src/modules/home/components/VisitPaymentBanner.tsx
msgid "Visit partially paid"
msgstr "Visit partially paid"

#: src/modules/visit/PastVisit/VisitSummaryCard.tsx
msgid "Visit summary"
msgstr "Visit summary"

#: src/config/navigation.tsx
#: src/routes/_app/visits/index.tsx
msgid "Visits"
msgstr "Visits"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Voided"
msgstr "Voided"

#: src/modules/home/components/QuickActionsList.tsx
#: src/modules/maintenance/Summary.tsx
msgid "Warranties"
msgstr "Warranties"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Warranties, receipts and important documents safe in one place"
msgstr "Warranties, receipts and important documents safe in one place"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Warranty certificates and reminders"
msgstr "Warranty certificates and reminders"

#: src/modules/consumption/ConsumptionChart.tsx
#: src/modules/consumption/utils.ts
#: src/modules/consumption/utils.ts
msgid "Water"
msgstr "Water"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage doesn't choose a time. We are there when you need us."
msgstr "Water damage doesn't choose a time. We are there when you need us."

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency 24/7"
msgstr "Water damage emergency 24/7"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency help"
msgstr "Water damage emergency help"

#: src/modules/home/components/EmergencyWaterDamageCard.tsx
msgid "Water damage emergency service included in all Markku packages"
msgstr "Water damage emergency service included in all Markku packages"

#: src/modules/home/components/PropertyHeroCard.tsx
msgid "Water leak"
msgstr "Water leak"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "We are constantly expanding our service area!"
msgstr "We are constantly expanding our service area!"

#: src/modules/auth/OtpStep.tsx
msgid "We sent a 6-digit code to:"
msgstr "We sent a 6-digit code to:"

#: src/routes/_app/messages/$id.tsx
msgid "We serve weekdays 8am-4pm"
msgstr "We serve weekdays 8am-4pm"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/index.tsx
msgid "We will book the survey visit with these details"
msgstr "We will book the survey visit with these details"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "We will contact you before the visit using these details."
msgstr "We will contact you before the visit using these details."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "We will contact you before the visit."
msgstr "We will contact you before the visit."

#: src/modules/auth/EmailStep.tsx
msgid "We will send a login code to your email"
msgstr "We will send a login code to your email"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/ContactInfoStep.tsx
msgid "We will use these details to book your survey visit"
msgstr "We will use these details to book your survey visit"

#: src/modules/home/components/FrontpageWelcome.tsx
msgid "Welcome to Markku maintenance book"
msgstr "Welcome to Markku maintenance book"

#: src/modules/auth/WelcomeStep.tsx
msgid "Welcome to Markku!"
msgstr "Welcome to Markku!"

#: src/modules/visit/FeedbackModal.tsx
msgid "What could be improved?"
msgstr "What could be improved?"

#: src/modules/visit/FeedbackModal.tsx
msgid "What went well?"
msgstr "What went well?"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/CityStep.tsx
msgid "Where is the property located?"
msgstr "Where is the property located?"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Window cleaning"
msgstr "Window cleaning"

#: src/modules/home/components/SeasonalTasksCard.tsx
msgid "Winter"
msgstr "Winter"

#: src/modules/maintenance/YearCalendarCarousel/utils.ts
msgid "Winter tasks"
msgstr "Winter tasks"

#: src/modules/maintenance/components/TaskDetails/TaskForm.tsx
msgid "winter's"
msgstr "winter's"

#: src/modules/visit/PastVisit/InvoiceItem.tsx
msgid "Wire transfer"
msgstr "Wire transfer"

#: src/modules/visit/PastVisit/WireTransferModal.tsx
msgid "Wire transfer instructions"
msgstr "Wire transfer instructions"

#: src/modules/maintenance/components/MarkkuSavingsCard.tsx
msgid "With the Markku package, you save {savedHours}h per year and {savedTasks} maintenance tasks"
msgstr "With the Markku package, you save {savedHours}h per year and {savedTasks} maintenance tasks"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
#: src/modules/maintenance/components/TaskDetails/CompletionForm.tsx
msgid "Work completion date"
msgstr "Work completion date"

#: src/routes/_app/maintenance-log/index.tsx
msgid "Year"
msgstr "Year"

#: src/modules/consumption/index.tsx
#: src/modules/consumption/index.tsx
msgid "Year {selectedYear} consumption"
msgstr "Year {selectedYear} consumption"

#: src/modules/costs/CostsPage/index.tsx
#: src/modules/costs/CostsPage/index.tsx
msgid "Year {year} cost tracking"
msgstr "Year {year} cost tracking"

#: src/modules/costs/CostsPage/CostsSummaryCard.tsx
msgid "Year {year} summary"
msgstr "Year {year} summary"

#: src/routes/_app/maintenance.tsx
msgid "Year calendar"
msgstr "Year calendar"

#: src/modules/home/components/ServiceStatusCard.tsx
msgid "Year progress"
msgstr "Year progress"

#: src/modules/consumption/ConsumptionGuidance.tsx
msgid "You can add an optional cost in euros if you also want to track your expenses"
msgstr "You can add an optional cost in euros if you also want to track your expenses"

#: src/modules/costs/CostsPage/CostsHelpCard.tsx
msgid "You can also add costs directly on this page using the \"Add\" button"
msgstr "You can also add costs directly on this page using the \"Add\" button"

#: src/modules/subscription/components/PackageListSection.tsx
msgid "You can change to another package at any time."
msgstr "You can change to another package at any time."

#: src/modules/auth/WelcomeStep.tsx
msgid "You must accept the terms of service to continue."
msgstr "You must accept the terms of service to continue."

#: src/modules/auth/WelcomeLogin.tsx
msgid "You must log in to continue."
msgstr "You must log in to continue."

#: src/components/profile/NotificationSettings.tsx
msgid "You receive notifications on this device"
msgstr "You receive notifications on this device"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskInfo.tsx
msgid "Your browser does not support the video tag."
msgstr "Your browser does not support the video tag."

#: src/modules/visit/FeedbackModal.tsx
msgid "Your feedback has been saved successfully."
msgstr "Your feedback has been saved successfully."

#: src/modules/subscription/components/BookSurveyVisitModal/steps/SuccessStep.tsx
msgid "Your free survey visit has been booked"
msgstr "Your free survey visit has been booked"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Your maintenance log is now ready to use"
msgstr "Your maintenance log is now ready to use"

#: src/modules/home/components/QuickActionsList.tsx
msgid "Your Markku package"
msgstr "Your Markku package"

#: src/components/property/WelcomePropertyModal.tsx
msgid "Your property has been added!"
msgstr "Your property has been added!"

#: src/modules/maintenance/components/SystemTaskDetails/SystemTaskForm.tsx
msgid "Your property value is preserved"
msgstr "Your property value is preserved"

#: src/modules/subscription/components/BookSurveyVisitModal/steps/InfoStep/BookingSummary.tsx
msgid "Your selected time"
msgstr "Your selected time"
